import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import React, { useEffect } from "react";
import FormParticipation from "./digital-participation/FormParticipation";
import store from "../store";
import { Box } from "@mui/material";
import { updateCurrentCity } from "../stores/Cities";
import "../styles/DigitalParticipation.css";
import { useTranslation } from "react-i18next";

export default function DigitalParticipation() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const urlParams = useParams();
  const navigate = useNavigate();

  const listCities = Object.keys(store.getState().cities.listCities);

  useEffect(() => {
    const urlParamCityName = urlParams.cityName;
    const currentCity = store.getState().cities.currentCity;
    if (
        urlParamCityName !== currentCity &&
        listCities.includes(urlParamCityName)
    ) {
        // Update of the current city in the store
        dispatch(updateCurrentCity(urlParamCityName));
    } else {
        // Invalid city and no city yet explored
        if (currentCity === "") {
            navigate("/home");
        }
        // Redirection to the previous city explored
        else if (urlParamCityName !== currentCity) {
            navigate("/sump/digital-participation/" + currentCity);
        }
    }
  }, [urlParams, listCities, dispatch, navigate]);


  return (
    <div className="intro-text">
    <Box
        display = 'flex'
        justifyContent='center'
        p={1}
        m= {1}
        bgcolor="white"
    >
      <Box
        display="flex"
        width={'75%'}
        bgcolor="#7bb3f6"
        color="#ffffff"
        p={1}
        borderRadius= {2}
      >
        <div>
          <p dangerouslySetInnerHTML={{ __html: t("Digital Participation Introduction.paragraph1") }}></p>
          <p dangerouslySetInnerHTML={{ __html: t("Digital Participation Introduction.paragraph2") }}></p>
          <p dangerouslySetInnerHTML={{ __html: t("Digital Participation Introduction.paragraph3") }}></p>
          <p dangerouslySetInnerHTML={{ __html: t("Digital Participation Introduction.paragraph4") }}></p>
        </div>
      </Box>
      </Box>
          <FormParticipation />
      </div>
  );
}
